import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import {MoveToBankComponent} from './move-to-bank/move-to-bank.component'
import { HomeComponent } from '../app/home/home.component';
import { AuthGuard } from './auth/auth.guard';
import { KYCGuard } from './auth/kyc.guard';
import { AgentPermisionGuard } from './auth/agent-permision.guard';
import { RechargeComponent } from './recharge/recharge/recharge.component';
import { RechargeWalletComponent } from './recharge-wallet/recharge-wallet.component';
import { MoveToDistributorComponent } from './move-to-distributor/move-to-distributor.component';
import { DthRechargeComponent } from './dth-recharge/dth-recharge.component';
import { KycComponent } from './kyc/kyc.component';
import { DeviceConfigurationTutorialComponent } from './device-configuration-tutorial/device-configuration-tutorial.component';
import { TdsCertificateComponent } from './tds-certificate/tds-certificate.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { YesBankBeneficiaryComponent } from './dmt/yes-bank-beneficiary/yes-bank-beneficiary.component';
import { RetailerCertificateComponent } from './retailer-certificate/retailer-certificate.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { YBKycGuard } from './auth/YBKyc.guard';
import { YesBankEkycComponent } from './yes-bank-ekyc/yes-bank-ekyc.component';
import { UsefullLinksComponent } from './usefull-links/usefull-links.component';
import { MyPlansComponent } from './my-plans/my-plans.component';
import { MediaTypeComponent } from './media-type/media-type.component';
import { ComplaintComponent } from './complaint/complaint.component';
import { ComplaintChatComponent } from './complaint-chat/complaint-chat.component';
import { EarningReportExportComponent } from './earning-report-export/earning-report-export.component';
import { PanServiceComponent } from './pan-service/pan-service.component';
import { EarningDashboardComponent } from './earning-dashboard/earning-dashboard.component';
import { TwoFactorAuthenticationComponent } from './two-factor-authentication/two-factor-authentication.component';
import { MatmbuyComponent } from './matmbuy/matmbuy.component';
import { CmsComponent } from './cms/cms.component';
import { AirtelcmsComponent } from './airtelcms/airtelcms.component';
const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [AuthGuard] }, 
  { path: 'login', component: LoginComponent},
  { path: 'kyc', component: KycComponent  },
  { path: 'dashboard', loadChildren: () => import('../app/dashboard/dashboard.module').then(d => d.DashboardModule) },
  { path: 'recharge', loadChildren: () => import('../app/recharge/recharge.module').then(r => r.RechargeModule) },
  { path: 'aeps', loadChildren: () => import('../app/aeps/aeps.module').then(r => r.AepsModule)},
  // , canActivate: [KYCGuard]
  { path: 'dmt', loadChildren: () => import('../app/dmt/dmt.module').then(dmt => dmt.DMTModule)},
  { path: 'Yesbank-dmt', loadChildren: () => import('../app/yes-bank-dmt/yes-bank-dmt.module').then(Yesbankdmt => Yesbankdmt.YesBankDmtModule),canActivate: [YBKycGuard]},
  { path: 'history', loadChildren: () => import('../app/laser/laser.module').then(laser => laser.LaserModule) },
  { path: 'move-to-bank', component: MoveToBankComponent },
  { path: 'mATM', component: MatmbuyComponent },
  { path: 'cms', component: CmsComponent },
  { path: 'airtelcms', component: AirtelcmsComponent },

  { path: 'move-to-distributor', component: MoveToDistributorComponent },
  { path: 'recharge-wallet', component: RechargeWalletComponent },
  { path: 'dth-recharge', component: DthRechargeComponent },
  { path: 'device-configuration-tutorial',component:DeviceConfigurationTutorialComponent},
  { path: "tds-certificate",component: TdsCertificateComponent },
  {path: "notifications",component:NotificationsComponent},
  {path: "retailer-certificate",component:RetailerCertificateComponent},
  { path: "complaint",component: ComplaintComponent},
  { path: "complaint-chat/:complaintId",component: ComplaintChatComponent},

  { path: "Contact-Us",component: ContactUsComponent},
  {path:"yes-bank-ekyc", component:YesBankEkycComponent},
  { path: 'yes-bank-beneficiary/:mobile/:id/:name/:bank',component:YesBankBeneficiaryComponent},

  { path: "useful-links",component: UsefullLinksComponent},
  { path: "my-plans",component: MyPlansComponent},
  { path: "media-type",component: MediaTypeComponent},
  {path:'earning-report-export',component:EarningReportExportComponent},
  {path:'pan-service',component:PanServiceComponent},
  {path:'earnings',component:EarningDashboardComponent},
  { path:'two-factor-auth/:service/:selectedServiceType', component: TwoFactorAuthenticationComponent },

  // tslint:disable-next-line: max-line-length
  { path: 'customerDetails/:mobile/:id/:name/:bank', loadChildren: () => import('../app/login-customer/login-customer.module').then(lc => lc.LoginCustomerModule) },
  
  // tslint:disable-next-line: max-line-length
  { path: 'agent-onboarding', loadChildren: () => import('../app/agent-onboarding/agent-onboarding.module').then(ag => ag.AgentOnboardingModule) },
  { path: 'notification', loadChildren: () => import('../app/notification/notification.module').then(notify => notify.NotificationModule) },
  // tslint:disable-next-line: max-line-length
  { path: 'manage-tickets', loadChildren: () => import('../app/manage-tickets/manage-tickets.module').then(tickets => tickets.ManageTicketsModule) },
  // tslint:disable-next-line: max-line-length
  { path: 'commission-management', loadChildren: () => import('../app/commission/commission.module').then(commision => commision.CommissionModule) },
  { path: 'distributor', loadChildren: () => import('../app/distributors/distributors.module').then(distri => distri.DistributorsModule) },
  { path: 'bharatbillpay', loadChildren: () => import('./bharatbillpay/bharatbillpay.module').then(bharat => bharat.BharatbillpayModule) },
 { path: 'bank-management', loadChildren:()=> import('./bank-management/bank-management.module').then(bankmang=>bankmang.BankManagementModule)},
  // dev-only design reference for the EasyRin kit (Phase 1)
  { path: 'gallery', loadChildren: () => import('./gallery/gallery.module').then(g => g.GalleryModule) },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
